import { useState } from 'react'

interface IProps {
  config: any
  setConfig: React.Dispatch<React.SetStateAction<any[]>>
  data: any
  closeModal: () => void
}

const CustomBotName: React.FC<IProps> = ({ config, setConfig, data, closeModal }) => {
  const [botName, setBotName] = useState(config.theme ? config.theme.headerTitle : '')
  const [botDescription, setBotDescription] = useState<any>()

  const handleSave = async () => {
    closeModal()
  }

  return (
    <div className='d-flex flex-column'>
      {!!config.theme && (
        <>
          <h4 className='mb-5'>Chatbot Name</h4>
          <input
            className='form-control form-control-solid'
            name='headerTitle'
            value={botName}
            onChange={(e) => setBotName(e.target.value)}
          />
          <h4 className='mb-5 mt-6'>Chatbot Description</h4>
          <textarea
            className='form-control form-control-solid'
            autoComplete='off'
            style={{ height: '100px', resize: 'none' }}
            value={botDescription}
            onChange={(e) => setBotDescription(e.target.value)}
          ></textarea>
        </>
      )}
      <button className='btn btn-primary ms-auto mt-8' onClick={handleSave}>
        <i className='bi bi-save' /> Save
      </button>
    </div>
  )
}

export default CustomBotName
